import React, { useState,useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthContext.tsx";
import logo from "../assets/logo.png";
import "../components/LoginPageStyle.scss";
import { message, Button,Checkbox,Typography } from "antd";
import { apiCall } from "../api/apiRoutes.ts";
import { NetworkInfo } from "../constants/network.ts";
import {useLocation} from "react-router-dom"
import { FaRegEyeSlash, FaRegEye } from "react-icons/fa";
import showMessageQueue from '../utils/messageUtils.js';

const { Text } = Typography;

const LoginPage: React.FC = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const webUserId = queryParams.get("web_user_id");
  const authCode = queryParams.get("auth_code");
  const [loginData, setLoginData] = useState({
    username: "",
    password: "",
  });
  const { login } = useAuth();
  const navigate = useNavigate();
  const [loading,setLoading]=useState(false)
  const [messages, contextHolder] = message.useMessage();
  const [rememberMe, setRememberMe] = useState(false);
  const [showPassword, setShowPassword] = useState(false); 

  useEffect(() => {
    const storedCredentials = localStorage.getItem("credentials");
    if (storedCredentials) {
      const parsedData = JSON.parse(storedCredentials); // correct parsing
      setLoginData(parsedData)
      setRememberMe(true);
    }
  }, []); 

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!loginData.username || !loginData.password) {
      showMessageQueue(messages,"error","Please enter both email and password.")
      return;
    }

    /*
    const payload={
      email:loginData?.username?.trim(),
      password:loginData?.password?.trim()
     }
    */
    const credentials = `${loginData?.username?.trim()}:${loginData?.password?.trim()}`;
    const encodedCredentials = btoa(credentials);
    
    
    try {
      setLoading(true)
      const response:any = await apiCall(encodedCredentials,`${NetworkInfo.endpoints.auth}${NetworkInfo.endpoints.login}`,"post",false,false,false);      
      if (response.statusCode === 200) {
          login(response?.data,"login"); // Set authentication state
          navigate("/home");
          setLoginData({username: "",password: ""})
          setLoading(false)
          if (rememberMe) {
            const data={
              username:loginData.username,
              password:loginData.password
            }
            localStorage.setItem("credentials", JSON.stringify(data));
          }
      } else if(response?.status===400) {
          setLoading(false)
          showMessageQueue(messages,"error",response?.response?.data?.message)
          if(!rememberMe){
            localStorage.removeItem("credentials");
          }
      }
    } catch (error) {
      setLoading(false)
      showMessageQueue(messages,"error",error?.response?.data?.message || "Login failed. Check your credentials and try again." )

      if(!rememberMe){
        localStorage.removeItem("credentials");
      }
    }
  };

  useEffect(() => {
    const fetchPatient = async () => {
      try {
        const data = {
          webUserId: Number(webUserId),
          authCode: authCode
        };
        const response = await apiCall(data, `${NetworkInfo.endpoints.auth}${NetworkInfo.endpoints.verifyUser}`, "post", false, false, false);
        if (response.statusCode === 200) {
          login(response?.data, "login"); // Set authentication state
          navigate("/home");
          setLoading(false);
        } else if (response?.status === 400) {
          setLoading(false);
          showMessageQueue(messages,"error",response?.response?.data?.message )
        }
      } catch (error) {
        setLoading(false);
        showMessageQueue(messages,"error","Login failed. Invalid auth code or web user id.")
      }
    };
  
    if (webUserId && authCode) {
      fetchPatient();
    } 
  }, [webUserId, authCode,login,messages,navigate]); // Now it has no missing dependencies
  

  const handleRememberMeChange = (value) => {
    if (value === true) {
      setRememberMe(true);
      let loginUser = loginData;
      localStorage.setItem("credentials", JSON.stringify(loginUser));
    } else {
      setRememberMe(false);
      localStorage.removeItem("credentials");
    }
  };

  const handleInputChange = (e) => {
    // console.log('e: ', e);
    const { name, value } = e.target;
    setLoginData({ ...loginData, [name]: value });
  };


  return (
    <div className="login-container">
      {contextHolder}
      <div className="login-card">
        <img src={logo} alt="USMON Logo" className="login-logo" />
        <div className="login-title">Welcome to USMON</div>
        <div className="login-subtitle">Insights</div>
        <form onSubmit={handleSubmit} className="login-form">
          <input
            type="text"
            placeholder="Corporate email"
            value={loginData.username}
            onChange={handleInputChange}            
            className="login-input"
            name="username"
            autoComplete="username"

          />
          <div className="password-container">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={loginData.password}
              onChange={handleInputChange}            
              className="login-input"
              name="password"
              autoComplete="current-password"
            />
            <span
              className="password-toggle-icon"
              onClick={() => setShowPassword((prev) => !prev)}
            >
              {showPassword ? <FaRegEye /> : <FaRegEyeSlash />}
            </span>
          </div>
          <div className="login-remember-me">
          <Checkbox
              className="mb-3 login-checkbox-label"
              type="checkbox"
              id="remember"
              onChange={(e) =>
                handleRememberMeChange(e.target.checked)
              }
              checked={rememberMe}
            >Remember Me</Checkbox>            
          </div>
          <Button htmlType="submit" className="login-button" loading={loading}>
            Log In
          </Button>
            <Text className="login-note">
              Don't have an account?{' '}
              <span
                style={{ color: '#1890ff', cursor: 'pointer' }}
                onClick={() => navigate('/sign-up')}
              >
                Sign Up
              </span>
            </Text>
        </form>
        <p className="login-footer">
          Please note, you can only have <strong>one session open at a time</strong>. For the best experience, we recommend using this application on web devices.
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
